import { createFileRoute, redirect } from "@tanstack/react-router";

// Keep legacy bookmarks working while Positions Tree is the sole Positions workspace.
export const Route = createFileRoute("/eex/positions")({
  beforeLoad: () => {
    throw redirect({ to: "/eex/positions-tree" });
  },
});
